import { render, staticRenderFns } from "./ContactHome.vue?vue&type=template&id=08152b7a&scoped=true&"
import script from "./ContactHome.vue?vue&type=script&lang=js&"
export * from "./ContactHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08152b7a",
  null
  
)

export default component.exports